<mat-dialog-content class="mat-typography askForHelpContainer">
    <h1>
        Sélectionner les couleurs à intégrer à votre palette.
    </h1>
    <article class="colorArticle">
        <h3>Couleur primaire : </h3>
        <p><span>{{color1}}</span><input [(colorPicker)]="color1" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="color1"/></p>
    </article>
    <article class="colorArticle">
        <h3>Couleur secondaire : </h3>
        <p><span>{{color2}}</span><input [(colorPicker)]="color2" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="color2"/></p>
    </article>
    <article class="colorArticle">
        <h3>Couleur tertiaire : </h3>
        <p><span>{{color3}}</span><input [(colorPicker)]="color3" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="color3"/></p>
    </article>
    <article class="colorArticle">
        <h3>Couleur quaternaire : </h3>
        <p><span>{{color4}}</span><input [(colorPicker)]="color4" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="color4"/></p>
    </article>
    <article class="colorArticle">
        <h3>Couleur complémentaire : </h3>
        <p><span>{{color5}}</span><input [(colorPicker)]="color5" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="color5"/></p>
    </article>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false"  cdkFocusInitial>Annuler</button>

    <button mat-raised-button (click)="validColor()" [disabled]="!color1">Enregistrer</button>
</mat-dialog-actions>